export default __webpack_public_path__ + "static/Room-With-A-View-Eiffel-Tower-43f1d27415fc8aa9fbc407df0b8fca31.jpg";